export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function fmtNum(v, line) {
  if (v === null || v === undefined || Number.isNaN(v)) return "-";
  if (line?.is_ratio) {
    if (/%|percent|persen/i.test(line.label || "")) return `${(v * 100).toFixed(2)}%`;
    const vals = (line.fy || []).filter((x) => x !== null);
    const isPct = vals.length ? vals.every((x) => Math.abs(x) <= 1.5) : Math.abs(v) <= 1.5;
    return isPct ? `${(v * 100).toFixed(2)}%` : v.toFixed(2);
  }
  if (line?.driver === "stat_occupancy") return `${(v * 100).toFixed(2)}%`;
  const abs = Math.abs(v);
  const countStat = /^stat_(rooms|covers|manning|days)/.test(line?.driver || "");
  const s = abs < 1000 && abs !== Math.round(abs) && !countStat ? abs.toLocaleString("en-US", { maximumFractionDigits: 2 }) : Math.round(abs).toLocaleString("en-US");
  return v < 0 ? `(${s})` : s;
}

export function fmtCompact(v) {
  if (v === null || v === undefined) return "-";
  const abs = Math.abs(v);
  let s;
  if (abs >= 1e12) s = `${(abs / 1e12).toFixed(2)} T`;
  else if (abs >= 1e9) s = `${(abs / 1e9).toFixed(2)} B`;
  else if (abs >= 1e6) s = `${(abs / 1e6).toFixed(1)} M`;
  else s = Math.round(abs).toLocaleString("en-US");
  return v < 0 ? `-${s}` : s;
}

export function fmtPct(v, digits = 2) {
  if (v === null || v === undefined || Number.isNaN(v)) return "-";
  return `${v > 0 ? "+" : ""}${v.toFixed(digits)}%`;
}

export function fmtIdr(v, digits = 0) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "-";
  return `Rp ${Number(v).toLocaleString("id-ID", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

export function fmtRate(v, ccy) {
  if (v === null || v === undefined) return "-";
  if (ccy === "IDR") return fmtIdr(v);
  return Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 4 });
}

export const DRIVER_LABELS = {
  revenue_rooms: "Rooms revenue", revenue_fnb: "F&B revenue", revenue_other: "Other revenue", payroll: "Payroll",
  cogs: "Cost of sales", utilities: "Utilities", other_expense: "Operating expense", fixed_charges: "Fixed charges",
  management_fee: "Management fee", stat_rooms_available: "Rooms available", stat_rooms_sold: "Rooms sold", stat_other_rooms: "Comp / house use / OOO rooms",
  stat_occupancy: "Occupancy", stat_adr: "ADR", stat_revpar: "RevPAR", stat_avg_check: "Avg check", stat_covers: "Guests/covers",
  stat_manning: "Manning", stat_days: "Days", stat_fixed: "Constant", ratio_keep: "Ratio (keep)", blended: "Total (blended)", header: "",
};

export const DRIVER_GROUPS = [
  { label: "Revenue", ids: ["revenue_rooms", "revenue_fnb", "revenue_other"] },
  { label: "Expenses", ids: ["payroll", "cogs", "utilities", "other_expense", "fixed_charges", "management_fee"] },
  { label: "Statistics", ids: ["stat_rooms_available", "stat_rooms_sold", "stat_other_rooms", "stat_occupancy", "stat_adr", "stat_revpar", "stat_avg_check", "stat_covers", "stat_manning", "stat_days", "stat_fixed"] },
  { label: "Other", ids: ["ratio_keep", "blended"] },
];
